// src/pages/LanguageSetting.jsx
import React, { Fragment, useContext, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Leftnav from "../components/Leftnav";
import Appfooter from "../components/Appfooter";
import { useTranslation } from "react-i18next";
import i18n from "../i18n";
import { SnackbarContext } from "../context/SnackbarContext";
import { useAPI } from "../context/ApiContext";

const LanguageSetting = () => {
  const { t } = useTranslation();
  const api = useAPI();
  const { newSnack } = useContext(SnackbarContext);
  const current = useMemo(() => api?.clientSettings?.language || i18n.language || "ja", [api?.clientSettings, i18n.language]);
  const [saving, setSaving] = useState(false);

  const applyLang = async (lang) => {
    if (saving) return;
    setSaving(true);
    try {
      // 先に即時反映
      if (i18n.language !== lang) i18n.changeLanguage(lang);
      // サーバ保存
      await api.updateMyClientSettings({ language: lang });
      newSnack("success", lang === "ja" ? "日本語に切り替えました" : "Language changed to English");
      // 再取得（任意）
      try { await api.getMyClientSettings(); } catch {}
    } catch (e) {
      newSnack("error", t("SaveFailed") || "保存に失敗しました");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Fragment>
      <Header />
      <Leftnav />

      <div className="main-content bg-lightblue theme-dark-bg right-chat-active">
        <div className="middle-sidebar-bottom">
          <div className="middle-sidebar-left">
            <div className="middle-wrap">
              <div className="card w-100 border-0 bg-white shadow-xs p-0 mb-4">
                <div className="card-body p-4 w-100 bg-current border-0 d-flex rounded-3">
                  <Link to="/settings" className="d-inline-block mt-2">
                    <i className="ti-arrow-left font-sm text-white"></i>
                  </Link>
                  <h4 className="font-xs text-white fw-600 ms-4 mb-0 mt-2">
                    {t("LanguageSetting1") || "言語設定"}
                  </h4>
                  {saving && <span className="ms-auto font-xssss text-white-50">Saving…</span>}
                </div>

                <div className="card-body p-lg-5 p-4 w-100 border-0">
                  <div className="nav-caption fw-600 font-xsss text-grey-500 mb-2">
                    {t("LanguageSetting2") || "言語"}
                  </div>

                  <div className="d-flex flex-wrap gap-2">
                    <button
                      className={`btn ${current === "ja" ? "bg-current text-white" : "btn-outline-primary"} font-xsss fw-600 p-3 rounded-3 me-2`}
                      onClick={() => applyLang("ja")}
                      disabled={saving || current === "ja"}
                    >
                      日本語にする
                    </button>
                    <button
                      className={`btn ${current === "en" ? "bg-current text-white" : "btn-outline-primary"} font-xsss fw-600 p-3 rounded-3`}
                      onClick={() => applyLang("en")}
                      disabled={saving || current === "en"}
                    >
                      Switch to English
                    </button>
                  </div>

                  <div className="mt-3 font-xssss text-grey-600">
                    {t("LanguageSetting3") || "選択した言語はアプリ全体に適用されます。"}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>  

      <Appfooter />
    </Fragment>
  );
};

export default LanguageSetting;
